import { DataGrid } from '@mui/x-data-grid';
import { useState, useEffect } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { Stack } from '@mui/material';
import { TableGridProps } from './types';
import { useTranslation } from 'react-i18next';

const TableGrid = (props: TableGridProps) => {
  const {
    columns,
    rows,
    page: pageProp = 0,
    pageSize: pageSizeProp = 10,
    isFetching,
    paginationMode = 'client',
    rowsPerPageOptions = [10, 20, 50, 100],
    totalCount,
    hidePagination = false,
    fetchingFunction,
    checkboxSelection = false,
    onRowSelectionModelChange,
    rowSelectionModel,
    ...rest } = props;
  const [page, setPage] = useState(pageProp);
  const [pageSize, setPageSize] = useState(pageSizeProp);
  const { t } = useTranslation();

  //disable tooltip header 
  const editedColumns = columns.map(x=>{
    return { ...x,

      renderHeader: () => <>{x.headerName}</>
    };});
  const isServerSidePaginated = paginationMode === 'server';

  useEffect(() => {
    isServerSidePaginated && fetchingFunction
      && fetchingFunction(pageSize, page);
  }, [page, pageSize]);


  return (
    <>
      <DataGrid
        checkboxSelection={checkboxSelection}
        {...(checkboxSelection && {
          onSelectionModelChange: onRowSelectionModelChange,
          selectionModel: rowSelectionModel,
          keepNonExistentRowsSelected: true
        })}
        hideFooter={hidePagination}
        getRowId={(row) => JSON.stringify(row)}
        getRowHeight={() => 'auto'}
        autoHeight
        pagination
        page={page}
        rowCount={totalCount
          ? Number(totalCount)
          : rows.length
        }
        disableSelectionOnClick
        disableColumnMenu
        loading={isFetching}
        onPageSizeChange={(newPageSize: number) => (
          setPageSize && setPageSize(newPageSize)
        )}
        columns={editedColumns}
        pageSize={hidePagination
          ? 100
          : pageSize}
        rowsPerPageOptions={rowsPerPageOptions}
        {...rest}
        headerHeight={60}
        paginationMode={paginationMode}
        onPageChange={(newPage: number) => isServerSidePaginated && setPage(newPage)}
        rows={rows.length === 0
          ? []
          : rows}
        componentsProps={{

          pagination: {
            SelectProps: {
              MenuProps: {
                disablePortal: true,
              }
            }
          }
        }}

        components={{
          LoadingOverlay: LinearProgress,
          NoRowsOverlay: () => (
            <Stack height='100%' alignItems='center'
              justifyContent='center'>
              {t('Δεν υπάρχουν εγγραφές')}
            </Stack>
          )
        }}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#F2F2F2',
            fontSize: 16
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            textOverflow: 'clip',
            whiteSpace: 'break-spaces',
            lineHeight: 1
          },
          '& .MuiDataGrid-columnHeader: focus': {
            outline: 'none'
          },
          '& .MuiDataGrid-cell': {
            py: 1,
            textOverflow: 'ellipsis',
            whiteSpace: 'break-spaces',
          }
        }}
      />
    </>
  );
};

export default TableGrid;